import { useQuery } from "@tanstack/react-query";
import { getTransactionFeesHunterUserIDEarnings } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const TRANSACTIONS_FEES_HUNTER_QUERY_KEY = "TRANSACTIONS_FEES_HUNTER";

export const getTransactionsFeesHunterQueryKey = (
  userID: number,
  dateFrom?: string | null,
  dateTo?: string | null,
) => [TRANSACTIONS_FEES_HUNTER_QUERY_KEY, userID, dateFrom, dateTo];

export const useTransactionsFeesHunterDetailEarnings = (
  userID: number,
  dateFrom?: string | null,
  dateTo?: string | null,
) =>
  useQuery({
    queryKey: getTransactionsFeesHunterQueryKey(userID, dateFrom, dateTo),
    queryFn: processResponseWithApiProblemDetails(() =>
      getTransactionFeesHunterUserIDEarnings(userID, dateFrom, dateTo),
    ),
  });
